// extracted by mini-css-extract-plugin
export default {"worksPage":"Works_worksPage__ojx5C"};